// extracted by mini-css-extract-plugin
export default {"cardTopics":"review_cardTopics__GUdvS","cardValues":"review_cardValues__TfPCa","subTopicDivider":"review_subTopicDivider__MwLJ8"};